import { getObjValue } from 'utils/functions';

const isFetchingAssessment = props => getObjValue(props, 'data.loading', true);
const getAssessment = props => getObjValue(props, 'data.getAssessmentById', null);
const getDdeActions = props => getObjValue(props, 'getDDEActions.getDDEActions', null);

export { isFetchingAssessment, getAssessment, getDdeActions };
